import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";

// Office Monitoring reducers
import {
  complianceRecordReducer,
  dateRangeSelectedReducer,
  activeUserReducer,
  overrideFormDataReducer,
} from "pages/officeMonitoring/state/reducers";
import { monthSelectedReducer } from "pages/timelog/state/reducers";

// Self Help Desk reducers
import { selectedTestsReducer } from "pages/selfHelpDesk/state/reducers";

// CubeDEX reducers
import {
  dateRangeReducer,
  filtersReducer,
  utilizationDataReducer,
} from "pages/cubedex/state/reducers";

export const globalStore = configureStore({
  reducer: {
    // Global user state
    user: userReducer,

    // Office Monitoring
    complianceRecord: complianceRecordReducer,
    dateRangeSelected: dateRangeSelectedReducer,
    activeUser: activeUserReducer,
    overrideFormData: overrideFormDataReducer,
    monthSelected: monthSelectedReducer,

    // Self Help Desk
    selectedTests: selectedTestsReducer,

    // CubeDEX
    dateRange: dateRangeReducer,
    filters: filtersReducer,
    utilizationData: utilizationDataReducer,
  },
});
